import domReady from '@wordpress/dom-ready';
import { queryCarouselVariation } from "./variations/query-carousel";
import { carouselSwiper } from "./core/query";

domReady( () => {
	queryCarouselVariation();
	carouselSwiper();
});
